var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check-all",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.42,
    height: 14.665,
    viewBox: "0 0 27.42 14.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M20.183,11.182a1.688,1.688,0,1,1,2.41,2.363L13.611,24.773a1.688,1.688,0,0,1-2.43.045L5.229,18.864a1.688,1.688,0,1,1,2.385-2.385l4.712,4.709,7.811-9.956a.567.567,0,0,1,.045-.049Zm-2.07,11.565,2.07,2.07a1.688,1.688,0,0,0,2.428-.045l8.982-11.228a1.688,1.688,0,1,0-2.455-2.313l-7.815,9.957-1.091-1.093L18.11,22.748Z",
    transform: "translate(-4.682 -10.647)",
    fill: "#07c914",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckAll);
export default __webpack_public_path__ + "static/media/icon-check-all.d9aab4306c72ade18701cb92220421ea.svg";
export { ForwardRef as ReactComponent };